export const dashboardMockData = {
  user: {
    displayName: "John",
  },
  reportingPeriod: "July 26",
  summary: [
    {
      id: "total",
      label: "Total",
      value: 123,
      caption: "All PAF",
      tone: "primary",
      icon: "clipboard",
    },
    {
      id: "completed",
      label: "Completed",
      value: 12,
      caption: "Completed PAF",
      tone: "success",
      icon: "check",
    },
    {
      id: "pending",
      label: "Pending",
      value: 3,
      caption: "Pending PAF",
      tone: "pending",
      icon: "clock",
    },
    {
      id: "delayed",
      label: "Delayed",
      value: 2,
      caption: "Delayed PAF",
      tone: "warning",
      icon: "hourglass",
    },
  ],
  calendar: {
    initialDate: null,
    events: [],
  },
  upcomingPafs: [],
};

// Each section declares its own access metadata so API data, role checks, and
// user widget preferences can be added without changing the page layout.
export const dashboardSections = [
  {
    id: "summary",
    enabled: true,
    roles: ["*"],
    permissions: [],
  },
  {
    id: "schedule",
    enabled: true,
    roles: ["*"],
    permissions: [],
  },
];

export const getVisibleDashboardSections = ({
  roles = [],
  permissions = [],
  preferences = {},
} = {}) =>
  dashboardSections.filter((section) => {
    const roleAllowed =
      section.roles.includes("*") ||
      section.roles.some((role) => roles.includes(role));
    const permissionsAllowed = section.permissions.every((permission) =>
      permissions.includes(permission)
    );
    const preferenceAllowed = preferences[section.id] !== false;

    return (
      section.enabled &&
      roleAllowed &&
      permissionsAllowed &&
      preferenceAllowed
    );
  });

export const getPublishedUpcomingPafs = (upcomingPafs) =>
  upcomingPafs.filter((paf) => paf.status === "Published");
